import { uGet, uSet } from "../core/storage";

const KEY = "state";

export interface PersistState {
  tf: string;
  crosshair: boolean;
  volume: boolean;
  dszone: boolean;
  magnet: boolean;
}

export function loadState(): Partial<PersistState> {
  try {
    const raw = uGet(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveState(s: Partial<PersistState>) {
  try {
    const prev = loadState();
    uSet(KEY, JSON.stringify({ ...prev, ...s }));
  } catch {}
}
